// COMPONENTS
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";
import { IconButton, TableCell } from "@mui/material";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import StatusComponent from "@/main/components/shared/status/statusComponent";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/GetApp";

// UTILS/HOOKS
import { RoutesConstants } from "@/main/routes/routesConstants";
import { useNavigate } from "react-router-dom";
import { ReportTemplateGridResponse } from "@/main/models/response";
import { ReportTemplateFileRequest } from "@/main/models/request";
import { fileImportApi } from "@/main/api";
import { getTranslateByKey } from "@/main/services/utils";
import { downloadFile } from "@/main/services/utilsFile";

import * as S from "./styles";

interface IRowReportTemplateProps {
	reportTemplate: ReportTemplateGridResponse;
	index: number;
}

function RowReportTemplate({ reportTemplate }: IRowReportTemplateProps) {
	const navigate = useNavigate();

	function handleRowBoxGrid(registerGuid: string) {
		navigate(`${RoutesConstants.registrationRegisterReportTemplate}?guidTemplate=${registerGuid}`);
	}

	async function handleDownload(reportTemplate: ReportTemplateGridResponse) {
		const request: ReportTemplateFileRequest = {
			guidTemplate: reportTemplate.guid,
		};
		const {
			data: { result },
		} = await fileImportApi.getFileReportTemplate(request);
		downloadFile(
			result.file,
			`${reportTemplate.reportName} - ${reportTemplate.companyName}`,
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		);
	}

	return (
		<KOGTableRow $notClickable key={reportTemplate.guid}>
			<TableCell width="15%">{reportTemplate.companyType}</TableCell>
			<TableCell width="20%" title={reportTemplate.companyName}>
				<div
					style={{
						maxWidth: 400,
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
					}}
				>
					{reportTemplate.companyName}
				</div>
			</TableCell>
			<TableCell width="25%">{reportTemplate.reportName}</TableCell>
			<TableCell width="20%">{reportTemplate.lastUpdate}</TableCell>
			<TableCell width="10%">
				<StatusComponent status={reportTemplate?.statusRegister} />
			</TableCell>

			<TableCell width="5%">
				<S.ActionButtons>
					<TooltipComponent title={`${getTranslateByKey("information.editReportTemplate")}`}>
						<IconButton
							id={`id-searchReportTemplate-edit-${reportTemplate.reportName}`}
							color="primary"
							onClick={() => handleRowBoxGrid(reportTemplate.guid)}
						>
							<EditIcon />
						</IconButton>
					</TooltipComponent>
					<TooltipComponent title={`${getTranslateByKey("information.downloadTemplate")}`}>
						<IconButton
							id={`id-searchReportTemplate-download-${reportTemplate.reportName}`}
							color="primary"
							onClick={() => handleDownload(reportTemplate)}
						>
							<DownloadIcon />
						</IconButton>
					</TooltipComponent>
				</S.ActionButtons>
			</TableCell>
		</KOGTableRow>
	);
}

export default RowReportTemplate;
